import { Deck } from '@deckplan.io/common';
import { CardService } from '../../cards/card.service';
import { MatDialog } from '@angular/material/dialog';
import { Commander } from './commander';
import { Freeform } from './freeform';
import { Format } from './format.interface';
import { Standard } from './standard';
import { Legacy } from './legacy';
import { Modern } from './modern';
import { Vintage } from './vintage';
import { Pioneer } from './pioneer';
import { Pauper } from './pauper';
import { Brawl } from './brawl';

export class FormatFactory {

    public static create(deck: Deck, cardsService: CardService, dialog: MatDialog, isReadOnly: boolean): Format {
        const format = deck.format;
        if (format === 'Commander') {
            return new Commander(deck, cardsService, dialog, isReadOnly);
        } else if (format === 'Brawl') {
            return new Brawl(deck, cardsService, dialog, isReadOnly);
        } else if (format === 'Standard') {
            return new Standard(deck, cardsService, dialog, isReadOnly);
        } else if (format === 'Legacy') {
            return new Legacy(deck, cardsService, dialog, isReadOnly);
        } else if (format === 'Modern') {
            return new Modern(deck, cardsService, dialog, isReadOnly);
        } else if (format === 'Vintage') {
            return new Vintage(deck, cardsService, dialog, isReadOnly);
        } else if (format === 'Pioneer') {
            return new Pioneer(deck, cardsService, dialog, isReadOnly);
        } else if (format === 'Pauper') {
            return new Pauper(deck, cardsService, dialog, isReadOnly);
        } else {
            return new Freeform(deck, cardsService, dialog, isReadOnly);
        }
    }

}
